($ => {
  const nav_toggle = $('.js-nav-toggle');
  var nav;
  var nav_object;
  var last_clicked;

  nav_toggle.on('click', function () {
    nav = $(this).data('toggle');
    nav_object = $(nav);

    if (last_clicked != nav && last_clicked != undefined) {
      closeAll();
    }

    last_clicked = nav;

    if ($(this).hasClass('is-active')) {
      // hide menu
      toggleClose($(this), nav_object);
    } else {
      // show menu
      toggleOpen($(this), nav_object);
    }

    function toggleOpen(button, target) {
      overlay.showOverlay();
      $('body').addClass('modal-open');
      button.attr('aria-expanded', true);
      button.addClass('is-active');
      target.addClass('show');
    }

    function toggleClose(button, target) {
      overlay.hideOverlay();
      $('body').removeClass('modal-open');
      button.attr('aria-expanded', false);
      button.removeClass('is-active');
      target.removeClass('show');
    }

    function closeAll() {
      nav_toggle.each(function () {
        if ($(this).hasClass('is-active')) {
          var data_toggle = $(this).data('toggle');
          var target = $(data_toggle);
          toggleClose($(this), target);
        }
      });
    }
  });
})(jQuery);
